export default __webpack_public_path__ + "static/media/diamond.df83f50b.png";